import { Pyramide, PyramidePDFSettings } from 'types/pyramide';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  lng: string;
  settings: PyramidePDFSettings;
  groups?: string[];
  pyramide: Pyramide;
}

export function buildPyramideParams({
  lng,
  settings,
  groups,
  pyramide,
}: Props) {
  const params = new URLSearchParams({
    lng,
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
    boysColor: settings.boysColor || 'blue-500',
    girlsColor: settings.girlsColor || 'pink-500',
    neutralColor: settings.neutralColor || 'gray-500',
    layout: settings.layout || 'byMonths',
    formatNameStyle: settings.formatNameStyle || 'givenNameOnly',
  });

  if (!_isEmpty(pyramide.title)) {
    params.set('title', pyramide.title);
  }

  if (!_isEmpty(pyramide.subtitle)) {
    params.set('subtitle', pyramide.subtitle!);
  }

  if (groups && groups.length > 0) {
    params.set('groups', groups.join(','));
  }
  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
